export enum DateType {
  HOSPITALIZATION_DATE = 'LNG_REFERENCE_DATA_CATEGORY_PERSON_DATE_TYPE_HOSPITALIZATION',
  ISOLATION_DATE = 'LNG_REFERENCE_DATA_CATEGORY_PERSON_DATE_TYPE_ISOLATION'
}
